export default __webpack_public_path__ + "static/media/logo-black.aa7bfc9b.ico";